module.exports = __webpack_public_path__ + "img/ICON_Target_Colors.73426ac7.svg";